import type { SelectedAddon } from "./aggregate-selected-addons";

// Addons of one seller within a position's selection (MPL-3833 / MPL-3834).
export type SellerAddonsGroup = {
  // Merchant id of the seller; owner-less catalog rows count as the catering's.
  key: string;
  // Display name: the catalog's merchantName, the diet's catering for its own
  // addons without one, undefined when nothing is known.
  name?: string;
  isDietMerchant: boolean;
  items: SelectedAddon[];
  totalQuantity: number;
  // Sum of the rows' totals, deposits inside — same semantics as the summary.
  productTotal: number;
  depositTotal: number;
};

// Split the aggregated selection by who sells each addon. The diet's catering
// comes first, the other merchants follow in the order their first addon has
// in the catalog. Amounts are just summed from the rows: the grouping adds no
// pricing of its own.
export const groupSelectedAddonsBySeller = (
  items: SelectedAddon[],
  {
    dietMerchantId,
    cateringName,
  }: {
    dietMerchantId: string;
    cateringName?: string;
  },
): SellerAddonsGroup[] => {
  const groups = new Map<string, SellerAddonsGroup>();

  for (const item of items) {
    const key = item.addon.merchantId ?? dietMerchantId;
    const isDietMerchant = key === dietMerchantId;
    const group = groups.get(key) ?? {
      key,
      name:
        item.addon.merchantName ?? (isDietMerchant ? cateringName : undefined),
      isDietMerchant,
      items: [],
      totalQuantity: 0,
      productTotal: 0,
      depositTotal: 0,
    };

    group.items.push(item);
    group.totalQuantity += item.totalQuantity;
    group.productTotal += item.productTotal;
    group.depositTotal += item.depositTotal;
    groups.set(key, group);
  }

  return [...groups.values()].sort(
    (left, right) => Number(right.isDietMerchant) - Number(left.isDietMerchant),
  );
};
